export const CLIENTS = 'clients';
export const TRAINERS = 'trainers';
export const LOOKUP = 'lookups';
export const TIMELINE = 'timelines';
export const NUTRITIONS = 'nutritions';
export const NOTES = 'notes';
export const WORKOUTS = 'workouts';
export const FOOD = 'food';
export const PROGRESS_IMAGES = 'progressImages';
export const REPS = 'reps';
export const EXERCISES = 'exercises';
export const GOALS = 'goals';
export const ASSESSMENTS = 'assessments';
export const DETAILS = 'details';
export const LOGS = 'logs';
export const KICKSTART_RESPONSES = 'kickstartResponses';
export const NUTRITION_SUMMARY = 'nutrition_summary';
export const TRACK = 'track';
export const GRAPHS = 'graphs';
export const WATER = 'water';
export const EXERCISE = 'exercise';
export const BLOOD_PRESSURE = 'blood_pressure';
export const STEPS = 'steps';
export const DIGESTION = 'digestion';
export const CRAVING = 'craving';
export const HUNGER = 'hunger';
export const ENERGY = 'energy';
export const SLEEP = 'sleep';
export const WEIGHT = 'weight';
export const HEART_RATE = 'resting_heart_rate';
export const ADHERENCE = 'adherence';
export const NOTIFICATIONS = 'notifications';
export const ONBOARDING_QUESTIONS = 'onboardingQuestions';
export const ONBOARDING_RESPONSES = 'onboardingResponses';
export const ONBOARDING_RESPONSES_DETAILS = 'onboardingResponsesDetails';
export const GYMS = 'gyms';
